import { enableProdMode } from '@angular/core';
import { environment } from '@skylab/environments';

import { applyPolyfills, defineCustomElements } from '@inscomponents/core/loader';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

applyPolyfills().then(() => {
	defineCustomElements(window);
});

if (!environment.dev) {
	enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err =>
	console.error(err)
);
